import {apiClientv1} from './apiClient';
import { AgencyVoucher, VoucherAgencyFilters, VoucherCreationRequest } from '../types/agency.types';

export const agencyVoucherService = {
  /**
   * Récupère tous les vouchers liés à une agence spécifique
   * @param agencyId Identifiant de l'agence
   */
getByAgency: (filters?: VoucherAgencyFilters) =>
  apiClientv1.get<AgencyVoucher[]>('/vouchers/agency', {
    params: {
      status: filters?.status,
      token: filters?.token,
      amountMin: filters?.amountMin,
      amountMax: filters?.amountMax,
    },
  }),

  
  /**
   * Crée un nouveau voucher pour une agence 
   * @param agencyId Identifiant de l'agence
   * @param voucherData Données du voucher à créer
   */
  create: (agencyId: number, voucherData: VoucherCreationRequest) =>
    apiClientv1.post<AgencyVoucher>(`/vouchers/new-voucher`, {
      ...voucherData,
      agencyId
    }),
  
  /**
   * Transfère un voucher à un abonné
   * @param voucherId Identifiant du voucher
   * @param subscriberId Identifiant de l'abonné
   */
  transferToSubscriber: (voucherId: number, subscriberId: number) =>
    apiClientv1.post<AgencyVoucher>(`/vouchers/transfer-to-subscriber?idVoucher=${voucherId}&idSub=${subscriberId}`),
  
  /**
   * Valide un voucher
   * @param voucherId Identifiant du voucher
   */
  validate: (voucherId: number) =>
    apiClientv1.post<AgencyVoucher>(`/vouchers/validate?idVoucher=${voucherId}`),
  
  /**
   * Récupère tous les vouchers liés à un abonné spécifique
   * @param subscriberId Identifiant de l'abonné
   */
  getBySubscriber: (subscriberId: number) =>
    apiClientv1.get<AgencyVoucher[]>(`/vouchers/subscriber?idSub=${subscriberId}`),
  
  /**
   * Met à jour la valeur d'un voucher
   * @param voucherId Identifiant du voucher
   * @param value Nouvelle valeur
   */
  updateValue: (voucherId: number, value: number) =>
    apiClientv1.put<AgencyVoucher>(`/vouchers/${voucherId}/value`, { value }),

  /**
   * Active un voucher (génère le profil eSIM)
   * @param voucherToken Token du voucher
   */
  bookVoucher: (voucherToken: string) =>
    apiClientv1.post('/subscriptions/voucher/book', {
      voucherToken,
      description: 'eSIM subscription',
    }),

  /**
   * Récupère la consommation eSIM d'un abonné via simSerial
   * @param simSerial Numéro de série de la SIM
   */
  getConsumption: (simSerial: string) =>
    apiClientv1.get('/subscribers/consumption/agency', {
      params: { simSerial },
    }),
};
